import Container from "./container";
import React from "react";
import { cn } from "../lib/helpers";
import Icon from "./icon";
import Links from "./links";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";

import * as styles from "../styles/components/page-header-integration.module.css";

const PageHeader = (props) => {
  const {
    name,
    description,
    logo,
    slug,
    href
  } = props;

  return (
    <div className={cn(styles.root, styles.dark)}>
      <Container>
        <div className="grid" style={{alignItems: 'center'}}>
        <div className={cn("col-12 col-md-4", styles.image)} style={{margin: 'auto'}}>
            {logo &&
              <img
                src={`/logos/${logo}`}
                alt={name}
              />
            }
        </div>
        <div className={cn("col-12 col-md-8", styles.headerInfo)}>
            <div className="content-sm">
              {name && <h1 className={cn("h3", styles.title)}>{name}</h1>}
              {description && <p>{description}</p>}
              {href &&
                  <Links button={{url: href, text: `Visit ${name}`, blank: true}} dark="true" />
                }
            </div>
        </div>
        </div>
        <div className={cn("dots-header-img-wrapper", styles.dotsHeaderImgWrapper)}>
          <div className="m-hide"><Icon symbol="dots-header-img" /></div>
          <div className="d-hide"><Icon symbol="dots-header-img-m" /></div>
        </div>
      </Container>
    </div>
  );
}

export default PageHeader;